import(/* webpackMode: "eager", webpackExports: ["PlayPageBody"] */ "/vercel/path0/src/app/(app)/play/PlayPageBody.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlayOrderProvider"] */ "/vercel/path0/src/features/play/PlayOrderProvider.tsx");
